import { PALETTE, FONT_DISPLAY, FONT_MONO } from "@/components/cobrain/tokens";

/* Anonymised engagement snapshots: situation → what we built → what changed.
   Composites of early client work, in line with the page disclaimer. */

const SNAPS = [
  {
    who: "7-person trades company",
    before: "Missed calls went to voicemail all day. Nobody called them back until the next morning, if at all.",
    built: "Instant callback + booking on every missed call, wired into the existing scheduling tool.",
    after: "Every inbound call answered or returned in minutes, with the job on the calendar before the owner sees it.",
  },
  {
    who: "3-person clinic",
    before: "Recall and reminder outreach lived in one person's head and stalled whenever they took leave.",
    built: "Automated recall sequences off the patient list, with approval gates before anything sends.",
    after: "Recall runs every week without anyone remembering to run it, and the front desk gets its mornings back.",
  },
  {
    who: "12-person agency",
    before: "Quotes went out fast, then sat. Follow-up depended on whoever had a quiet afternoon.",
    built: "Quote follow-up sequence with escalation to a human when a client replies.",
    after: "No proposal goes cold unnoticed. The team only touches deals that are actually moving.",
  },
];

const Row = ({ label, text, strong }: { label: string; text: string; strong?: boolean }) => (
  <div style={{ display: "grid", gap: 4 }}>
    <span style={{ fontFamily: FONT_MONO, fontSize: 9.5, letterSpacing: "0.14em", textTransform: "uppercase", color: strong ? PALETTE.amber : PALETTE.muted, fontWeight: 700 }}>
      {label}
    </span>
    <span style={{ fontSize: 14, lineHeight: 1.55, color: strong ? PALETTE.ink : PALETTE.ink2 }}>{text}</span>
  </div>
);

export function EngagementSnapshots() {
  return (
    <div className="svc-grid" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 20 }}>
      {SNAPS.map((s) => (
        <article key={s.who} data-svc-card style={{
          background: PALETTE.card, border: `1px solid ${PALETTE.line}`, borderRadius: 18,
          padding: 24, display: "grid", gap: 16, alignContent: "start", height: "100%",
          transition: "transform 220ms ease, box-shadow 220ms ease",
        }}>
          <h3 style={{ fontFamily: FONT_DISPLAY, fontWeight: 400, fontSize: 23, margin: 0, letterSpacing: "-0.01em" }}>{s.who}</h3>
          <Row label="Before" text={s.before} />
          <Row label="What we built" text={s.built} />
          <Row label="After" text={s.after} strong />
        </article>
      ))}
    </div>
  );
}

export default EngagementSnapshots;
